function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouseGarage = function SvgHouseGarage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.7,
    height: 16.707
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M460.75 109.317h16",
    "data-name": "Shape 25",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-460.396 -92.96)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.25 95.817h13.863v9.977H462.25z",
    "data-name": "Rectangle-path 4",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-460.829 -89.437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.744 92.36a.56.56 0 0 0-.284-.489l-7.465-4.139a.52.52 0 0 0-.5 0l-7.465 4.139a.56.56 0 0 0-.284.489v.776a.544.544 0 0 0 .533.554h14.929a.544.544 0 0 0 .533-.554z",
    "data-name": "Shape 26",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-460.394 -87.31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.25 98.817h9.6v7.76h-9.6z",
    "data-name": "Rectangle-path 5",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-461.697 -90.22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.25 103.317h5.332",
    "data-name": "Shape 27",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-462.564 -91.394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.25 106.317h5.332",
    "data-name": "Shape 28",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-462.564 -92.177)"
  }));
};
export { SvgHouseGarage as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi43IiBoZWlnaHQ9IjE2LjcwNyIgdmlld0JveD0iMCAwIDE2LjcgMTYuNzA3Ij4KICAgIDxwYXRoIGRhdGEtbmFtZT0iU2hhcGUgMjUiIGQ9Ik00NjAuNzUgMTA5LjMxN2gxNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ2MC4zOTYgLTkyLjk2KSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzMzMztzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOi43cHgiLz4KICAgIDxwYXRoIGRhdGEtbmFtZT0iUmVjdGFuZ2xlLXBhdGggNCIgZD0iTTQ2Mi4yNSA5NS44MTdoMTMuODYzdjkuOTc3SDQ2Mi4yNXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NjAuODI5IC04OS40MzcpIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMzMzO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6LjdweCIvPgogICAgPHBhdGggZGF0YS1uYW1lPSJTaGFwZSAyNiIgZD0iTTQ3Ni43NDQgOTIuMzZhLjU1OS41NTkgMCAwIDAtLjI4NC0uNDg5bC03LjQ2NS00LjEzOWEuNTE4LjUxOCAwIDAgMC0uNSAwbC03LjQ2NSA0LjEzOWEuNTU5LjU1OSAwIDAgMC0uMjg0LjQ4OXYuNzc2YS41NDQuNTQ0IDAgMCAwIC41MzMuNTU0aDE0LjkyOWEuNTQ0LjU0NCAwIDAgMCAuNTMzLS41NTR6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDYwLjM5NCAtODcuMzEpIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMzMzO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6LjdweCIvPgogICAgPHBhdGggZGF0YS1uYW1lPSJSZWN0YW5nbGUtcGF0aCA1IiBkPSJNNDY1LjI1IDk4LjgxN2g5LjZ2Ny43NmgtOS42eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ2MS42OTcgLTkwLjIyKSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzMzMztzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOi43cHgiLz4KICAgIDxwYXRoIGRhdGEtbmFtZT0iU2hhcGUgMjciIGQ9Ik00NjguMjUgMTAzLjMxN2g1LjMzMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ2Mi41NjQgLTkxLjM5NCkiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiMzMzM7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDouN3B4Ii8+CiAgICA8cGF0aCBkYXRhLW5hbWU9IlNoYXBlIDI4IiBkPSJNNDY4LjI1IDEwNi4zMTdoNS4zMzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NjIuNTY0IC05Mi4xNzcpIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMzMzO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6LjdweCIvPgo8L3N2Zz4K";